module.exports = __webpack_public_path__ + "static/TiemposText-Regular-Italic-c3666ac10dbfcde9576f27e937ec0702.woff";